export default class MaterialRecordCreation {
  id: string | undefined
  iniesId!: number
  codeAcv: undefined
  provider!: string
  productReference!: string
  fdesName!: string
}
